import React, { useState, useRef,useEffect } from "react";
import './ArtistCarousel.css'
import CarouselBackIcon from './../../../images/carouselbackicon.png'
import CarouselNextIcon from './../../../images/carouselnexticon.png'
import gray from './../../../images/gray.png'
import jayparktxt from './../../../images/jayparktxt.png'
import djkhalidtxt from './../../../images/djkhalidtxt.png'
import jessitxt from './../../../images/jessitxt.png'
import koalatxt from './../../../images/koalatxt.png'
import graytxt from './../../../images/graytxt.png'
import artistweworkllines from './../../../images/artistweworkllines.png'
import artistweworkrlines from './../../../images/artistweworkrlines.png'
import artistweworkllinestab from './../../../images/artistweworkllinestab.png'
import artistweworkrlinestab from './../../../images/artistweworkrlinestab.png'
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';
import spotifyicon from './../../../images/spotifyicon.png'
import youtubeicon from './../../../images/youtubeicon.webp'
import youtubewicon from './../../../images/youtubewicon.png'
import instagramicon from './../../../images/instagramicon.png'
import instagramlogo from './../../../images/instagramlogo.png'
import instagramwicon from './../../../images/instagramwicon.png'
import spotifywicon from './../../../images/spotifywicon.webp'

function ArtistCarousel(){
    const [artistno,setArtistNo] = useState(1);
    const [carouselMotion,setCarouselMotion] = useState(1);
    const [progress1style,setProgress1Style] = useState("Progress1")

    const [artist1style,setArtist1Style] = useState("ArtistContainershow")
    const [artist11style,setArtist11Style] = useState("ArtistContainershow")
    const [artist12style,setArtist12Style] = useState("ArtistContainerhide")
    const [artist13style,setArtist13Style] = useState("ArtistContainerhide")
    const [artist14style,setArtist14Style] = useState("ArtistContainerhide")

    const [artist2style,setArtist2Style] = useState("ArtistContainerhide")
    const [artist21style,setArtist21Style] = useState("ArtistContainershow")
    const [artist22style,setArtist22Style] = useState("ArtistContainerhide")
    const [artist23style,setArtist23Style] = useState("ArtistContainerhide")
    const [artist24style,setArtist24Style] = useState("ArtistContainerhide")

    const [artist3style,setArtist3Style] = useState("ArtistContainerhide")
    const [artist31style,setArtist31Style] = useState("ArtistContainerhide")
    const [artist32style,setArtist32Style] = useState("ArtistContainerhide")
    const [artist33style,setArtist33Style] = useState("ArtistContainerhide")
    const [artist34style,setArtist34Style] = useState("ArtistContainerhide")
    const [artist35style,setArtist35Style] = useState("ArtistContainerhide")

    const [artist4style,setArtist4Style] = useState("ArtistContainerhide")
    const [artist41style,setArtist41Style] = useState("ArtistContainerhide")
    const [artist42style,setArtist42Style] = useState("ArtistContainerhide")
    const [artist43style,setArtist43Style] = useState("ArtistContainerhide")
    const [artist44style,setArtist44Style] = useState("ArtistContainerhide")
    const [artist45style,setArtist45Style] = useState("ArtistContainerhide")

    const [artist5style,setArtist5Style] = useState("ArtistContainerhide")
    const [artist51style,setArtist51Style] = useState("ArtistContainerhide")
    const [artist52style,setArtist52Style] = useState("ArtistContainerhide")
    const [artist53style,setArtist53Style] = useState("ArtistContainerhide")
    const [artist54style,setArtist54Style] = useState("ArtistContainerhide")
    const [artist55style,setArtist55Style] = useState("ArtistContainerhide")

    const [artist1imgstyle,setArtist1ImgStyle] = useState("ArtistImageshow")
    const [artist11imgstyle,setArtist11ImgStyle] = useState("ArtistImagehide")
    const [artist12imgstyle,setArtist12ImgStyle] = useState("ArtistImagehide")
    const [artist13imgstyle,setArtist13ImgStyle] = useState("ArtistImagehide")
    const [artist14imgstyle,setArtist14ImgStyle] = useState("ArtistImagehide")
    const [artist2imgstyle,setArtist2ImgStyle] = useState("ArtistImagehide")

    const [artist21imgstyle,setArtist21ImgStyle] = useState("ArtistImagehide")
    const [artist22imgstyle,setArtist22ImgStyle] = useState("ArtistImagehide")
    const [artist23imgstyle,setArtist23ImgStyle] = useState("ArtistImagehide")
    const [artist24imgstyle,setArtist24ImgStyle] = useState("ArtistImagehide")

    const [artist3imgstyle,setArtist3ImgStyle] = useState("ArtistImagehide")
    const [artist31imgstyle,setArtist31ImgStyle] = useState("ArtistImagehide")
    const [artist32imgstyle,setArtist32ImgStyle] = useState("ArtistImagehide")
    const [artist33imgstyle,setArtist33ImgStyle] = useState("ArtistImagehide")
    const [artist34imgstyle,setArtist34ImgStyle] = useState("ArtistImagehide")
    const [artist35imgstyle,setArtist35ImgStyle] = useState("ArtistImagehide")

    const [artist4imgstyle,setArtist4ImgStyle] = useState("ArtistImagehide")
    const [artist41imgstyle,setArtist41ImgStyle] = useState("ArtistImagehide")
    const [artist42imgstyle,setArtist42ImgStyle] = useState("ArtistImagehide")
    const [artist43imgstyle,setArtist43ImgStyle] = useState("ArtistImagehide")
    const [artist44imgstyle,setArtist44ImgStyle] = useState("ArtistImagehide")
    const [artist45imgstyle,setArtist45ImgStyle] = useState("ArtistImagehide")

    const [artist5imgstyle,setArtist5ImgStyle] = useState("ArtistImagehide")
    const [artist51imgstyle,setArtist51ImgStyle] = useState("ArtistImagehide")
    const [artist52imgstyle,setArtist52ImgStyle] = useState("ArtistImagehide")
    const [artist53imgstyle,setArtist53ImgStyle] = useState("ArtistImagehide")
    const [artist54imgstyle,setArtist54ImgStyle] = useState("ArtistImagehide")
    const [artist55imgstyle,setArtist55ImgStyle] = useState("ArtistImagehide")

    const [dimensions, setDimensions] = useState({ 
        height: window.innerHeight,
        width: window.innerWidth
      })
    const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })

    const handleResize = () => {
        setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
        });
      }

    const img = cld
      .image('cld-sample-5')
      .format('auto') // Optimize delivery by resizing and applying auto-format and auto-quality
      .quality('auto')
      .resize(auto().gravity(autoGravity()).width(200).height(200));

    useEffect(() => {
        window.addEventListener("resize", handleResize, false); 
      }, []);
     

    const prevArtist = () =>{
        if(artistno===5){
            setArtist5Style("ArtistContainerhidefromright")
            setArtist4Style("ArtistContainershowfromleft")
            setArtist42Style("ArtistContainershowfromleft")
            // setArtist42Style("ArtistContainerhidefromright")
            setArtist43Style("ArtistContainerhidefromright")
            setArtist44Style("ArtistContainerhidefromright")
            setArtist45Style("ArtistContainerhidefromright")
            setArtist5ImgStyle("ArtistImageslidedownhide")
            setArtist51ImgStyle("ArtistImageslidedownhide")
            setArtist52ImgStyle("ArtistImageslidedownhide")
            setArtist53ImgStyle("ArtistImageslidedownhide")
            setArtist54ImgStyle("ArtistImageslidedownhide")
            setArtist55ImgStyle("ArtistImageslidedownhide")
            setArtist42ImgStyle("ArtistImageslidedownshow")

            // setArtist5Style("ArtistContainerhidefromright")
            // setArtist4Style("ArtistContainershowfromleft")
            // setArtist5ImgStyle("ArtistImageslidedownhide")
            // setArtist4ImgStyle("ArtistImageslidedownshow")
        }
        if(artistno===4){
            setArtist4Style("ArtistContainerhidefromright")
            setArtist3Style("ArtistContainershowfromleft")
            setArtist32Style("ArtistContainershowfromleft")
            // setArtist32Style("ArtistContainerhidefromright")
            setArtist33Style("ArtistContainerhidefromright")
            setArtist34Style("ArtistContainerhidefromright")
            setArtist35Style("ArtistContainerhidefromright")
            setArtist4ImgStyle("ArtistImageslidedownhide")
            setArtist41ImgStyle("ArtistImageslidedownhide")
            setArtist42ImgStyle("ArtistImageslidedownhide")
            setArtist43ImgStyle("ArtistImageslidedownhide")
            setArtist44ImgStyle("ArtistImageslidedownhide")
            setArtist45ImgStyle("ArtistImageslidedownhide")
            setArtist32ImgStyle("ArtistImageslidedownshow")

            // setArtist4Style("ArtistContainerhidefromright")
            // setArtist3Style("ArtistContainershowfromleft")
            // setArtist4ImgStyle("ArtistImageslidedownhide")
            // setArtist31ImgStyle("ArtistImageslidedownshow")
        }
        if(artistno===3){
            setArtist3Style("ArtistContainerhidefromright")
            setArtist2Style("ArtistContainershowfromleft")
            setArtist21Style("ArtistContainershowfromleft")
            setArtist22Style("ArtistContainerhidefromright")
            setArtist23Style("ArtistContainerhidefromright")
            setArtist24Style("ArtistContainerhidefromright")
            setArtist3ImgStyle("ArtistImageslidedownhide")
            setArtist31ImgStyle("ArtistImageslidedownhide")
            setArtist32ImgStyle("ArtistImageslidedownhide")
            setArtist33ImgStyle("ArtistImageslidedownhide")
            setArtist34ImgStyle("ArtistImageslidedownhide")
            setArtist35ImgStyle("ArtistImageslidedownhide")
            setArtist2ImgStyle("ArtistImageslidedownshow")

            // setArtist3Style("ArtistContainerhidefromright")
            // setArtist2Style("ArtistContainershowfromleft")
            // setArtist31ImgStyle("ArtistImageslidedownhide")
            // setArtist32ImgStyle("ArtistImageslidedownhide")
            // setArtist33ImgStyle("ArtistImageslidedownhide")
            // setArtist34ImgStyle("ArtistImageslidedownhide")
            // setArtist35ImgStyle("ArtistImageslidedownhide")
            // setArtist2ImgStyle("ArtistImageslidedownshow")
        }
        if(artistno===2){
            setArtist2Style("ArtistContainerhidefromright")
            setArtist1Style("ArtistContainershowfromleft")
            setArtist11Style("ArtistContainershowfromleft")
            setArtist12Style("ArtistContainerhidefromright")
            setArtist13Style("ArtistContainerhidefromright")
            setArtist14Style("ArtistContainerhidefromright")
            setArtist2ImgStyle("ArtistImageslidedownhide")
            setArtist21ImgStyle("ArtistImageslidedownhide")
            setArtist22ImgStyle("ArtistImageslidedownhide")
            setArtist23ImgStyle("ArtistImageslidedownhide")
            setArtist24ImgStyle("ArtistImageslidedownhide")
            setArtist1ImgStyle("ArtistImageslidedownshow")
        }

        if(artistno!==1){
            console.log("Progressstepdown".concat(artistno-1))
            setProgress1Style("Progressstepdown".concat(artistno-1))
            setArtistNo(artistno-1)
        }
    }
    const nextArtist = () =>{
        if(artistno===1){
            setArtist1Style("ArtistContainerhidefromleft")
            setArtist2Style("ArtistContainershowfromright")
            setArtist21Style("ArtistContainershowfromright")
            setArtist22Style("ArtistContainerhidefromleft")
            setArtist23Style("ArtistContainerhidefromleft")
            setArtist24Style("ArtistContainerhidefromleft")
            setArtist1ImgStyle("ArtistImageslideuphide")
            setArtist11ImgStyle("ArtistImageslideuphide")
            setArtist12ImgStyle("ArtistImageslideuphide")
            setArtist13ImgStyle("ArtistImageslideuphide")
            setArtist14ImgStyle("ArtistImageslideuphide")
            setArtist2ImgStyle("ArtistImageslideupshow")
        }
        if(artistno===2){
            setArtist2Style("ArtistContainerhidefromleft")
            setArtist3Style("ArtistContainershowfromright")
            setArtist32Style("ArtistContainershowfromright")
            // setArtist32Style("ArtistContainerhidefromleft")
            setArtist33Style("ArtistContainerhidefromleft")
            setArtist34Style("ArtistContainerhidefromleft")
            setArtist35Style("ArtistContainerhidefromleft")
            setArtist2ImgStyle("ArtistImageslideuphide")
            setArtist21ImgStyle("ArtistImageslideuphide")
            setArtist22ImgStyle("ArtistImageslideuphide")
            setArtist23ImgStyle("ArtistImageslideuphide")
            setArtist24ImgStyle("ArtistImageslideuphide")
            setArtist32ImgStyle("ArtistImageslideupshow")
        }
        if(artistno===3){
            setArtist3Style("ArtistContainerhidefromleft")
            setArtist4Style("ArtistContainershowfromright")
            setArtist42Style("ArtistContainershowfromright")
            // setArtist42Style("ArtistContainerhidefromleft")
            setArtist43Style("ArtistContainerhidefromleft")
            setArtist44Style("ArtistContainerhidefromleft")
            setArtist45Style("ArtistContainerhidefromleft")
            setArtist31ImgStyle("ArtistImageslideuphide")
            setArtist32ImgStyle("ArtistImageslideuphide")
            setArtist33ImgStyle("ArtistImageslideuphide")
            setArtist34ImgStyle("ArtistImageslideuphide")
            setArtist35ImgStyle("ArtistImageslideuphide")
            setArtist42ImgStyle("ArtistImageslideupshow")

            // setArtist3Style("ArtistContainerhidefromleft")
            // setArtist4Style("ArtistContainershowfromright")
            // setArtist31ImgStyle("ArtistImageslideuphide")
            // setArtist4ImgStyle("ArtistImageslideupshow")
        }
        if(artistno===4){
            setArtist4Style("ArtistContainerhidefromleft")
            setArtist5Style("ArtistContainershowfromright")
            setArtist52Style("ArtistContainershowfromright")
            // setArtist52Style("ArtistContainerhidefromleft")
            setArtist53Style("ArtistContainerhidefromleft")
            setArtist54Style("ArtistContainerhidefromleft")
            setArtist55Style("ArtistContainerhidefromleft")
            setArtist41ImgStyle("ArtistImageslideuphide")
            setArtist42ImgStyle("ArtistImageslideuphide")
            setArtist43ImgStyle("ArtistImageslideuphide")
            setArtist44ImgStyle("ArtistImageslideuphide")
            setArtist45ImgStyle("ArtistImageslideuphide")
            setArtist52ImgStyle("ArtistImageslideupshow")

            // setArtist4Style("ArtistContainerhidefromleft")
            // setArtist5Style("ArtistContainershowfromright")
            // setArtist4ImgStyle("ArtistImageslideuphide")
            // setArtist5ImgStyle("ArtistImageslideupshow")
        }
      
        if(artistno!==5){
            console.log("Progressstepup".concat(artistno))
            setProgress1Style("Progressstepup".concat(artistno))
            setArtistNo(artistno+1)
            setCarouselMotion(carouselMotion+1)
        }
    }


    
    const slide1cycle = (index) =>{
        if(index===1){
            setArtist12Style("ArtistContainerhidefromleft")
            setArtist13Style("ArtistContainerhidefromleft")
            setArtist14Style("ArtistContainerhidefromleft")
            setArtist11Style("ArtistContainershowfromright")
            setArtist12ImgStyle("ArtistImageslideuphide")
            setArtist13ImgStyle("ArtistImageslideuphide")
            setArtist14ImgStyle("ArtistImageslideuphide")
            setArtist11ImgStyle("ArtistImageslideupshow")
        }
        if(index===2){
            setArtist11Style("ArtistContainerhidefromleft")
            setArtist13Style("ArtistContainerhidefromleft")
            setArtist14Style("ArtistContainerhidefromleft")
            setArtist12Style("ArtistContainershowfromright")
            setArtist11ImgStyle("ArtistImageslideuphide")
            setArtist13ImgStyle("ArtistImageslideuphide")
            setArtist14ImgStyle("ArtistImageslideuphide")
            setArtist12ImgStyle("ArtistImageslideupshow")
        }
        if(index===3){
            setArtist11Style("ArtistContainerhidefromleft")
            setArtist12Style("ArtistContainerhidefromleft")
            setArtist14Style("ArtistContainerhidefromleft")
            setArtist13Style("ArtistContainershowfromright")
            setArtist11ImgStyle("ArtistImageslideuphide")
            setArtist12ImgStyle("ArtistImageslideuphide")
            setArtist14ImgStyle("ArtistImageslideuphide")
            setArtist13ImgStyle("ArtistImageslideupshow")
        }
        if(index===4){
            setArtist11Style("ArtistContainerhidefromleft")
            setArtist12Style("ArtistContainerhidefromleft")
            setArtist13Style("ArtistContainerhidefromleft")
            setArtist14Style("ArtistContainershowfromright")
            setArtist11ImgStyle("ArtistImageslideuphide")
            setArtist12ImgStyle("ArtistImageslideuphide")
            setArtist13ImgStyle("ArtistImageslideuphide")
            setArtist14ImgStyle("ArtistImageslideupshow")
        }
    }

    const slide2cycle = (index) =>{
        if(index===1){
            setArtist22Style("ArtistContainerhidefromleft")
            setArtist23Style("ArtistContainerhidefromleft")
            setArtist24Style("ArtistContainerhidefromleft")
            setArtist21Style("ArtistContainershowfromright")
            setArtist22ImgStyle("ArtistImageslideuphide")
            setArtist23ImgStyle("ArtistImageslideuphide")
            setArtist24ImgStyle("ArtistImageslideuphide")
            setArtist21ImgStyle("ArtistImageslideupshow")
            setArtist2ImgStyle("ArtistImageslideupshow")
        }
        if(index===2){
            setArtist21Style("ArtistContainerhidefromleft")
            setArtist23Style("ArtistContainerhidefromleft")
            setArtist24Style("ArtistContainerhidefromleft")
            setArtist22Style("ArtistContainershowfromright")
            setArtist2ImgStyle("ArtistImageslideuphide")
            setArtist21ImgStyle("ArtistImageslideuphide")
            setArtist23ImgStyle("ArtistImageslideuphide")
            setArtist24ImgStyle("ArtistImageslideuphide")
            setArtist22ImgStyle("ArtistImageslideupshow")
        }
        if(index===3){
            setArtist21Style("ArtistContainerhidefromleft")
            setArtist22Style("ArtistContainerhidefromleft")
            setArtist24Style("ArtistContainerhidefromleft")
            setArtist23Style("ArtistContainershowfromright")
            setArtist2ImgStyle("ArtistImageslideuphide")
            setArtist21ImgStyle("ArtistImageslideuphide")
            setArtist22ImgStyle("ArtistImageslideuphide")
            setArtist24ImgStyle("ArtistImageslideuphide")
            setArtist23ImgStyle("ArtistImageslideupshow")
        }
        if(index===4){
            setArtist21Style("ArtistContainerhidefromleft")
            setArtist22Style("ArtistContainerhidefromleft")
            setArtist23Style("ArtistContainerhidefromleft")
            setArtist24Style("ArtistContainershowfromright")
            setArtist2ImgStyle("ArtistImageslideuphide")
            setArtist21ImgStyle("ArtistImageslideuphide")
            setArtist22ImgStyle("ArtistImageslideuphide")
            setArtist23ImgStyle("ArtistImageslideuphide")
            setArtist24ImgStyle("ArtistImageslideupshow")
        }
    }

    const slide3cycle = (index) =>{
        if(index===1){
            setArtist31Style("ArtistContainerhidefromleft")
            setArtist32Style("ArtistContainershowfromright")
            setArtist33Style("ArtistContainerhidefromleft")
            setArtist34Style("ArtistContainerhidefromleft")
            setArtist35Style("ArtistContainerhidefromleft")
           
            setArtist31ImgStyle("ArtistImageslideuphide")
            setArtist32ImgStyle("ArtistImageslideupshow")
            setArtist33ImgStyle("ArtistImageslideuphide")
            setArtist34ImgStyle("ArtistImageslideuphide")
            setArtist35ImgStyle("ArtistImageslideuphide")
        }

        if(index===2){
            setArtist31Style("ArtistContainerhidefromleft")
            setArtist32Style("ArtistContainerhidefromleft")
            setArtist33Style("ArtistContainershowfromright")
            setArtist34Style("ArtistContainerhidefromleft")
            setArtist35Style("ArtistContainerhidefromleft")

            setArtist31ImgStyle("ArtistImageslideuphide")
            setArtist32ImgStyle("ArtistImageslideuphide")
            setArtist33ImgStyle("ArtistImageslideupshow")
            setArtist34ImgStyle("ArtistImageslideuphide")
            setArtist35ImgStyle("ArtistImageslideuphide")
        }
        if(index===3){
            setArtist31Style("ArtistContainerhidefromleft")
            setArtist32Style("ArtistContainerhidefromleft")
            setArtist33Style("ArtistContainerhidefromleft")
            setArtist34Style("ArtistContainershowfromright")
            setArtist35Style("ArtistContainerhidefromleft")

            setArtist31ImgStyle("ArtistImageslideuphide")
            setArtist32ImgStyle("ArtistImageslideuphide")
            setArtist33ImgStyle("ArtistImageslideuphide")
            setArtist34ImgStyle("ArtistImageslideupshow")
            setArtist35ImgStyle("ArtistImageslideuphide")
        }
        if(index===4){
            setArtist31Style("ArtistContainerhidefromleft")
            setArtist32Style("ArtistContainerhidefromleft")
            setArtist33Style("ArtistContainerhidefromleft")
            setArtist34Style("ArtistContainerhidefromleft")
            setArtist35Style("ArtistContainershowfromright")

            setArtist31ImgStyle("ArtistImageslideuphide")
            setArtist32ImgStyle("ArtistImageslideuphide")
            setArtist33ImgStyle("ArtistImageslideuphide")
            setArtist34ImgStyle("ArtistImageslideuphide")
            setArtist35ImgStyle("ArtistImageslideupshow")
        }
    }

    const slide4cycle = (index) =>{
        if(index===1){
            setArtist41Style("ArtistContainerhidefromleft")
            setArtist42Style("ArtistContainershowfromright")
            setArtist43Style("ArtistContainerhidefromleft")
            setArtist44Style("ArtistContainerhidefromleft")
            setArtist45Style("ArtistContainerhidefromleft")
           
            setArtist41ImgStyle("ArtistImageslideuphide")
            setArtist42ImgStyle("ArtistImageslideupshow")
            setArtist43ImgStyle("ArtistImageslideuphide")
            setArtist44ImgStyle("ArtistImageslideuphide")
            setArtist45ImgStyle("ArtistImageslideuphide")
        }

        if(index===2){
            setArtist41Style("ArtistContainerhidefromleft")
            setArtist42Style("ArtistContainerhidefromleft")
            setArtist43Style("ArtistContainershowfromright")
            setArtist44Style("ArtistContainerhidefromleft")
            setArtist45Style("ArtistContainerhidefromleft")

            setArtist41ImgStyle("ArtistImageslideuphide")
            setArtist42ImgStyle("ArtistImageslideuphide")
            setArtist43ImgStyle("ArtistImageslideupshow")
            setArtist44ImgStyle("ArtistImageslideuphide")
            setArtist45ImgStyle("ArtistImageslideuphide")
        }
        if(index===3){
            setArtist41Style("ArtistContainerhidefromleft")
            setArtist42Style("ArtistContainerhidefromleft")
            setArtist43Style("ArtistContainerhidefromleft")
            setArtist44Style("ArtistContainershowfromright")
            setArtist45Style("ArtistContainerhidefromleft")

            setArtist41ImgStyle("ArtistImageslideuphide")
            setArtist42ImgStyle("ArtistImageslideuphide")
            setArtist43ImgStyle("ArtistImageslideuphide")
            setArtist44ImgStyle("ArtistImageslideupshow")
            setArtist45ImgStyle("ArtistImageslideuphide")
        }
        if(index===4){
            setArtist41Style("ArtistContainerhidefromleft")
            setArtist42Style("ArtistContainerhidefromleft")
            setArtist43Style("ArtistContainerhidefromleft")
            setArtist44Style("ArtistContainerhidefromleft")
            setArtist45Style("ArtistContainershowfromright")

            setArtist41ImgStyle("ArtistImageslideuphide")
            setArtist42ImgStyle("ArtistImageslideuphide")
            setArtist43ImgStyle("ArtistImageslideuphide")
            setArtist44ImgStyle("ArtistImageslideuphide")
            setArtist45ImgStyle("ArtistImageslideupshow")
        }
    }

    const slide5cycle = (index) =>{
        if(index===1){
            setArtist51Style("ArtistContainerhidefromleft")
            setArtist52Style("ArtistContainershowfromright")
            setArtist53Style("ArtistContainerhidefromleft")
            setArtist54Style("ArtistContainerhidefromleft")
            setArtist55Style("ArtistContainerhidefromleft")
           
            setArtist51ImgStyle("ArtistImageslideuphide")
            setArtist52ImgStyle("ArtistImageslideupshow")
            setArtist53ImgStyle("ArtistImageslideuphide")
            setArtist54ImgStyle("ArtistImageslideuphide")
            setArtist55ImgStyle("ArtistImageslideuphide")
        }

        if(index===2){
            setArtist51Style("ArtistContainerhidefromleft")
            setArtist52Style("ArtistContainerhidefromleft")
            setArtist53Style("ArtistContainershowfromright")
            setArtist54Style("ArtistContainerhidefromleft")
            setArtist55Style("ArtistContainerhidefromleft")

            setArtist51ImgStyle("ArtistImageslideuphide")
            setArtist52ImgStyle("ArtistImageslideuphide")
            setArtist53ImgStyle("ArtistImageslideupshow")
            setArtist54ImgStyle("ArtistImageslideuphide")
            setArtist55ImgStyle("ArtistImageslideuphide")
        }
        if(index===3){
            setArtist51Style("ArtistContainerhidefromleft")
            setArtist52Style("ArtistContainerhidefromleft")
            setArtist53Style("ArtistContainerhidefromleft")
            setArtist54Style("ArtistContainershowfromright")
            setArtist55Style("ArtistContainerhidefromleft")

            setArtist51ImgStyle("ArtistImageslideuphide")
            setArtist52ImgStyle("ArtistImageslideuphide")
            setArtist53ImgStyle("ArtistImageslideuphide")
            setArtist54ImgStyle("ArtistImageslideupshow")
            setArtist55ImgStyle("ArtistImageslideuphide")
        }
        if(index===4){
            setArtist51Style("ArtistContainerhidefromleft")
            setArtist52Style("ArtistContainerhidefromleft")
            setArtist53Style("ArtistContainerhidefromleft")
            setArtist54Style("ArtistContainerhidefromleft")
            setArtist55Style("ArtistContainershowfromright")

            setArtist51ImgStyle("ArtistImageslideuphide")
            setArtist52ImgStyle("ArtistImageslideuphide")
            setArtist53ImgStyle("ArtistImageslideuphide")
            setArtist54ImgStyle("ArtistImageslideuphide")
            setArtist55ImgStyle("ArtistImageslideupshow")
        }
    }



    return(
        <div>
        {/* ******************************************** */}


        {/* DESKTOP VIEW */}

        {
        dimensions.width >= 1024 &&
        <div style={{backgroundColor:'#0E141A',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingBottom:'5em',paddingTop:'5em',width:'100%'}}>
             
            

             <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'67.78%',maxWidth:'61em',position:'relative'}}>
                
                <img src={artistweworkllines} style={{width:'130px',height:'523.3px',position:'absolute',left:'-20em',top:'-0.2em',zIndex:'1'}}/>
                <img src={artistweworkrlines} style={{width:'156.67px',height:'381.31px',position:'absolute',right:'-20em',top:'6em',zIndex:'1'}}/>

                <div className="ArtistWeWrokWith" style={{marginBottom:'1.5em',width:'100%',minWidth:'61em',zIndex:'2'}}>
                        ARTISTS WE WORK WITH
                </div>

                
                
                    {/* <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={jayparkimg} style={{aspectRatio:'1.01',zIndex:'4'}}/>
                   
                    </div> */}

                

                <div style={{position:'relative',height:'27.5em',alignSelf:'center',width:'100%',minWidth:'61em',display:'flex',flexDirection:'row'}}>
                
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/wjw0au0sdzneyznlyez4"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist1imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/wjw0au0sdzneyznlyez4"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist11imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714409/ncSoft_il9cew.png"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist12imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739042238/mettalica_hf8iwz.webp"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist13imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1733946027/bnm36zixpuyawtojxms0.png"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist14imgstyle}/>

                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714409/pledis_b6xpbk.jpg"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist2imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739043332/seventeen_jm3vxz.webp"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist22imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/w_1000,ar_1:1,c_fill,g_auto,e_art:hokusai/v1738714411/morevision_kvmqta.png"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist23imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739041816/sik-k_zbpb2o.jpg"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist24imgstyle}/>

                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/gehvac7zkmxbvmy4dby6"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist31imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714411/jasonmarz_ffheza.webp"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist32imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714410/ph-1_uobolc.webp"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist33imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739043045/eminem_qgyklq.jpg"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist34imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714410/grovyroom_kludhz.jpg"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist35imgstyle}/>

                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/m6hklhckvdgkw3pq5sso"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist41imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/c_crop,w_1200,h_1200/v1739041171/woodie_eexnph.webp"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist42imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714410/tradel_xvd4yp.jpg"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist43imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739385622/djsoda_tgvgjw.jpg"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist44imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714410/johnoates_wtoyxy.jpg"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist45imgstyle}/>

                <img src={gray} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist51imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739483186/gretavanfleet_hae9ju.jpg"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist52imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714409/bluewatermusic_szc378.png"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist53imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739043220/connorprice_uhjmyh.jpg"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist54imgstyle}/>
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739042504/robinwilliams_c1gmfi.webp"} style={{width:'27.84em',height:'27.4em',zIndex:'4',position:'absolute',left:'0.5em'}} className={artist55imgstyle}/>
                


                <div style={{display:'flex',flexDirection:'row',paddingTop:'2em'}}  className={artist1style}>
                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <div style={{width:'27.84em',height:'27.4em',zIndex:'4',backgroundColor:'transparent'}}/>
                    {/* <div src={graytxt} style={{fontSize:'10rem',position:'absolute',right:'-3.3em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif'}}>Jay Park</div> */}
                    {/* <img src={jayparktxt} style={{position:'absolute',right:'-32em',zIndex:'3',top:'-2em'}}/> */}
                    <div style={{display:'flex',flexDirection:'row',position:'absolute',bottom:'0em',right:'-30.84em', width:'27.84em',zIndex:'6'}}>
                            
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/wjw0au0sdzneyznlyez4"} style={{width:'8.5em',height:'8.5em',marginRight:'0.4em',cursor:'pointer'}} onMouseOver={()=>slide1cycle(1)}/>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714409/ncSoft_il9cew.png"} style={{width:'8.5em',height:'8.5em',marginRight:'0.4em',cursor:'pointer'}} onMouseOver={()=>slide1cycle(2)}/>
                            
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739042238/mettalica_hf8iwz.webp"} style={{width:'8.5em',height:'8.5em',cursor:'pointer'}} onMouseOver={()=>slide1cycle(3)}/>
                                {/* <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1733946027/bnm36zixpuyawtojxms0.png"} style={{width:'25%',height:'10em',cursor:'pointer'}} onMouseOver={()=>slide1cycle(4)}/> */}
                            
                            
                        </div>
                    </div>

                    

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist11style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Jay Park</div>
                                <div className="ArtistName">Jay Park</div>
                                <div style={{display:'flex',flexDirection:'row',marginTop:'1em',alignItems:'center'}}>
                                    <a href="https://open.spotify.com/artist/4XDi67ZENZcbfKnvMnTYsI" target="_blank" style={{textDecoration:'none'}}><img src={spotifywicon} style={{width:'2.2em',height:'2.2em',marginRight:'0.3em',borderRadius:'100px'}}/></a>
                                    <a href="https://www.instagram.com/moresojuplease/?hl=en" target="_blank" style={{textDecoration:'none'}}><img src={instagramwicon} style={{width:'2em',height:'2em',marginRight:'0.5em',borderRadius:'100px'}}/></a>
                                    <a href="https://www.youtube.com/channel/UCK5fO9Q2gitao0M5yQvPnvw" target="_blank" style={{textDecoration:'none'}}><img src={youtubewicon} style={{width:'1.8em',height:'1.8em',borderRadius:'100px'}}/></a>
                                </div>
                                <div className="ArtistRoles">Artist & Singer</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist12style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>NCSOFT</div>
                                <div className="ArtistName">NCSOFT</div>
                                <div className="ArtistRoles">Game Developer</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist13style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Metallica</div>
                                <div className="ArtistName">Metallica</div>
                                <div className="ArtistRoles">Band</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist14style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>DJ Khalid</div>
                                <div className="ArtistName">DJ Khalid</div>
                                <div className="ArtistRoles">Artist & Producer</div>
                            </div>
                        </div>

                        
                   

                    
                </div>

                <div style={{display:'flex',flexDirection:'row',paddingTop:'2em'}}  className={artist2style}>
                    {/* <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <div style={{width:'27.84em',height:'27.4em',zIndex:'4',backgroundColor:'transparent'}}/>
                    <img src={djkhalidtxt} style={{position:'absolute',right:'-37em',zIndex:'3',top:'-2em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'relative',marginLeft:'3.06em'}}>
                    <div className="ArtistName">DJ Khaled</div>
                    <div className="ArtistRoles">Artist & Producer</div>

                    <div style={{display:'flex',flexDirection:'row',marginTop:'2em'}}>
                           
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714409/pledis_b6xpbk.jpg"} style={{width:'25%',height:'8em',marginRight:'0.4em'}}/>
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739043332/seventeen_jm3vxz.webp"} style={{width:'25%',height:'8em',marginRight:'0.4em'}}/>
                          
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/w_1000,ar_1:1,c_fill,g_auto,e_art:hokusai/v1738714411/morevision_kvmqta.png"} style={{width:'25%',height:'8em',marginRight:'0.4em'}}/>
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739041816/sik-k_zbpb2o.jpg"} style={{width:'25%',height:'8em'}}/>
                          
                          
                       </div>

   
                    </div> */}
                     <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <div style={{width:'27.84em',height:'27.4em',zIndex:'4',backgroundColor:'transparent'}}/>
                   
                    <div style={{display:'flex',flexDirection:'row',position:'absolute',bottom:'0em',right:'-30.84em', width:'27.84em',zIndex:'6'}}>
                            
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714409/pledis_b6xpbk.jpg"} style={{width:'8.5em',height:'8.5em',marginRight:'0.4em',cursor:'pointer'}} onMouseOver={()=>slide2cycle(1)}/>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739043332/seventeen_jm3vxz.webp"} style={{width:'8.5em',height:'8.5em',marginRight:'0.4em',cursor:'pointer'}} onMouseOver={()=>slide2cycle(2)}/>
                            
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/w_1000,ar_1:1,c_fill,g_auto,e_art:hokusai/v1738714411/morevision_kvmqta.png"} style={{width:'8.5em',height:'8.5em',cursor:'pointer'}} onMouseOver={()=>slide2cycle(3)}/>
                                {/* <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739041816/sik-k_zbpb2o.jpg"} style={{width:'25%',height:'10em',cursor:'pointer'}} onMouseOver={()=>slide2cycle(4)}/> */}
                            
                            
                        </div>
                    </div>

                    

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist21style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>PLEDIS Entertainment</div>
                                <div className="ArtistName">PLEDIS Entertainment</div>
                                <div className="ArtistRoles">Entertainment Company</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist22style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>SEVENTEEN</div>
                                <div className="ArtistName">SEVENTEEN</div>
                                <div className="ArtistRoles">Kpop group</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist23style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>MORE VISION</div>
                                <div className="ArtistName">MORE VISION</div>
                                <div className="ArtistRoles">Record Label</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist24style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Sik-K</div>
                                <div className="ArtistName">Sik-K</div>
                                <div className="ArtistRoles">Rapper</div>
                            </div>
                        </div>

                </div>


                <div style={{display:'flex',flexDirection:'row',paddingTop:'2em'}}  className={artist3style}>
                    {/* <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <div style={{width:'27.84em',height:'27.4em',zIndex:'4',backgroundColor:'transparent'}}/>
                    <img src={jessitxt} style={{position:'absolute',right:'-16.5em',zIndex:'3',top:'-2em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'relative',marginLeft:'3.06em'}}>
                        <div className="ArtistName">Jessi</div>
                        <div className="ArtistRoles">Singer</div>

                        <div style={{display:'flex',flexDirection:'row',marginTop:'2em'}}>
                           
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714411/jasonmarz_ffheza.webp"} style={{width:'25%',height:'8em',marginRight:'0.4em'}}/>
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714410/ph-1_uobolc.webp"} style={{width:'25%',height:'8em',marginRight:'0.4em'}}/>
                          
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739043045/eminem_qgyklq.jpg"} style={{width:'25%',height:'8em',marginRight:'0.4em'}}/>
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714410/grovyroom_kludhz.jpg"} style={{width:'25%',height:'8em'}}/>
                          
                          
                       </div>

                        
                    </div> */}
                     <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <div style={{width:'27.84em',height:'27.4em',zIndex:'4',backgroundColor:'transparent'}}/>
                   
                    <div style={{display:'flex',flexDirection:'row',position:'absolute',bottom:'0em',right:'-30.84em', width:'27.84em',zIndex:'6'}}>
                            
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714411/jasonmarz_ffheza.webp"} style={{width:'8.5em',height:'8.5em',marginRight:'0.4em',cursor:'pointer'}} onMouseOver={()=>slide3cycle(1)}/>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714410/ph-1_uobolc.webp"} style={{width:'8.5em',height:'8.5em',marginRight:'0.4em',cursor:'pointer'}} onMouseOver={()=>slide3cycle(2)}/>
                            
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739043045/eminem_qgyklq.jpg"} style={{width:'8.5em',height:'8.5em',cursor:'pointer'}} onMouseOver={()=>slide3cycle(3)}/>
                                {/* <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714410/grovyroom_kludhz.jpg"} style={{width:'25%',height:'10em',cursor:'pointer'}} onMouseOver={()=>slide3cycle(4)}/> */}
                            
                            
                        </div>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist31style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Jessi</div>
                                <div className="ArtistName">Jessi</div>
                                <div className="ArtistRoles">Singer</div>
                            </div>
                        </div>
                        

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist32style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Jason Mraz</div>
                                <div className="ArtistName">Jason Mraz</div>
                                <div className="ArtistRoles">Singer</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist33style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Ph-1</div>
                                <div className="ArtistName">Ph-1</div>
                                <div className="ArtistRoles">Rapper</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist34style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Eminem (Eight Mile Style)</div>
                                <div className="ArtistName">Eminem (Eight Mile Style)</div>
                                <div className="ArtistRoles">Rapper</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist35style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>GroovyRoom</div>
                                <div className="ArtistName">GroovyRoom</div>
                                <div className="ArtistRoles">DJ & Producer</div>
                            </div>
                        </div>
                </div>


                <div style={{display:'flex',flexDirection:'row',paddingTop:'2em'}}  className={artist4style}>
                    {/* <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <div style={{width:'27.84em',height:'27.4em',zIndex:'4',backgroundColor:'transparent'}}/>
                    <img src={koalatxt} style={{position:'absolute',right:'-17.5em',zIndex:'3',top:'-2em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'relative',marginLeft:'3.06em'}}>
                        <div className="ArtistName">Koala</div>
                        <div className="ArtistRoles">Artist</div>


                        <div style={{display:'flex',flexDirection:'row',marginTop:'2em'}}>
                           
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714410/woodie_ax8arf.png"} style={{width:'25%',height:'8em',marginRight:'0.4em'}}/>
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714410/tradel_xvd4yp.jpg"} style={{width:'25%',height:'8em',marginRight:'0.4em'}}/>
                          
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739385622/djsoda_tgvgjw.jpg"} style={{width:'25%',height:'8em',marginRight:'0.4em'}}/>
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714410/johnoates_wtoyxy.jpg"} style={{width:'25%',height:'8em'}}/>
                          
                         
                       </div>

                       
                    </div> */}

                <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <div style={{width:'27.84em',height:'27.4em',zIndex:'4',backgroundColor:'transparent'}}/>
                   
                    <div style={{display:'flex',flexDirection:'row',position:'absolute',bottom:'0em',right:'-30.84em', width:'28.84em',zIndex:'6'}}>
                            
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/c_crop,w_1200,h_1200/v1739041171/woodie_eexnph.webp"} style={{width:'8.5em',height:'8.5em',marginRight:'0.4em',cursor:'pointer'}} onMouseOver={()=>slide4cycle(1)}/>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714410/tradel_xvd4yp.jpg"} style={{width:'8.5em',height:'8.5em',marginRight:'0.4em',cursor:'pointer'}} onMouseOver={()=>slide4cycle(2)}/>
                            
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739385622/djsoda_tgvgjw.jpg"} style={{width:'8.5em',height:'8.5em',marginRight:'0.4em',cursor:'pointer'}} onMouseOver={()=>slide4cycle(3)}/>
                                {/* <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714410/johnoates_wtoyxy.jpg"} style={{width:'25%',height:'10em',cursor:'pointer'}} onMouseOver={()=>slide4cycle(4)}/> */}
                            
                            
                        </div>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist41style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Koala</div>
                                <div className="ArtistName">Koala</div>
                                <div className="ArtistRoles">Artist</div>
                            </div>
                        </div>
                        

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist42style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Woodie</div>
                                <div className="ArtistName">Woodie</div>
                                <div className="ArtistRoles">Rapper</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist43style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Trade L</div>
                                <div className="ArtistName">Trade L</div>
                                <div className="ArtistRoles">Rapper & Singer</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist44style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>DJ Soda</div>
                                <div className="ArtistName">DJ Soda</div>
                                <div className="ArtistRoles">DJ</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist45style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>John Oates</div>
                                <div className="ArtistName">John Oates</div>
                                <div className="ArtistRoles">Singer & Producer</div>
                            </div>
                        </div>

                </div>

                <div style={{display:'flex',flexDirection:'row',paddingTop:'2em'}}  className={artist5style}>
                    {/* <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <div style={{width:'27.84em',height:'27.4em',zIndex:'4',backgroundColor:'transparent'}}/>
                    <div src={graytxt} style={{fontSize:'10rem',position:'absolute',right:'-3.3em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,20%)',fontFamily:'ClashGrotesk-Regular,sans-serif'}}>Jay Park</div>

                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'relative',marginLeft:'3.06em'}}>
                        <div className="ArtistName">Gray</div>
                        <div className="ArtistRoles">Artist & Producer</div>

                        <div style={{display:'flex',flexDirection:'row',marginTop:'2em'}}>
                           
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739483186/gretavanfleet_hae9ju.jpg"} style={{width:'25%',height:'8em',marginRight:'0.4em'}}/>
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714409/bluewatermusic_szc378.png"} style={{width:'25%',height:'8em',marginRight:'0.4em'}}/>
                          
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739043220/connorprice_uhjmyh.jpg"} style={{width:'25%',height:'8em',marginRight:'0.4em'}}/>
                           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739042504/robinwilliams_c1gmfi.webp"} style={{width:'25%',height:'8em'}}/>
                          
                          
                       </div>

           
                    </div> */}
                    
                <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <div style={{width:'27.84em',height:'27.4em',zIndex:'4',backgroundColor:'transparent'}}/>
                   
                    <div style={{display:'flex',flexDirection:'row',position:'absolute',bottom:'0em',right:'-30.84em', width:'27.84em',zIndex:'6'}}>
                            
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739483186/gretavanfleet_hae9ju.jpg"} style={{width:'8.5em',height:'8.5em',marginRight:'0.4em',cursor:'pointer'}} onMouseOver={()=>slide5cycle(1)}/>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1738714409/bluewatermusic_szc378.png"} style={{width:'8.5em',height:'8.5em',marginRight:'0.4em',cursor:'pointer'}} onMouseOver={()=>slide5cycle(2)}/>
                            
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739043220/connorprice_uhjmyh.jpg"} style={{width:'8.5em',height:'8.5em',cursor:'pointer'}} onMouseOver={()=>slide5cycle(3)}/>
                                {/* <img src={"https://res.cloudinary.com/ddvootytq/image/upload/v1739042504/robinwilliams_c1gmfi.webp"} style={{width:'25%',height:'10em',cursor:'pointer'}} onMouseOver={()=>slide5cycle(4)}/> */}
                            
                            
                        </div>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist51style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Gray</div>
                                <div className="ArtistName">Gray</div>
                                <div className="ArtistRoles">Artist & Producer</div>
                            </div>
                        </div>
                        

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist52style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Greta Van Fleet</div>
                                <div className="ArtistName">Greta Van Fleet</div>
                                <div className="ArtistRoles">Rock Band</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist53style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Bluewater Music</div>
                                <div className="ArtistName">Bluewater Music</div>
                                <div className="ArtistRoles">Music publisher</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist54style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Connor Price</div>
                                <div className="ArtistName">Connor Price</div>
                                <div className="ArtistRoles">Actor & Rapper</div>
                            </div>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',width:'100%'}} className={artist55style}>
                            <div style={{position:'absolute', left:'32em',width:'100%'}}>
                                <div style={{fontSize:'10rem',position:'absolute',left:'-0.4em',zIndex:'3',top:'-0.5em',fontWeight:'500',color:'transparent',display:'inline-block',WebkitTextStroke:'1px rgba(255,255,255,0.3)',fontFamily:'ClashGrotesk-Regular,sans-serif',overflow:'visible',width:'250%'}}>Robin Williams Estate</div>
                                <div className="ArtistName">Robin Williams Estate</div>
                                <div className="ArtistRoles">Actor & Comedian</div>
                            </div>
                        </div>
                </div>


       

                </div>

             
                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'2.5em',width:'100%',minWidth:'61em'}}>
                    <div style={{height:'1px',width:'89.70%',position:'relative',backgroundColor:'rgba(255,255,255,50%)'}}>
                      <div className={progress1style} style={{height:'1px',position:'absolute',left:'0em',backgroundColor:'#FF6694',zIndex:'2'}}/>
                    </div>
                    {
                        artistno!==1 &&
                        <img src={CarouselBackIcon} className="artistCarouselBtn" style={{marginLeft:'1em',marginRight:'0.5em'}} onClick={()=>prevArtist()}/>
                    }
                    {
                        artistno===1 &&
                        <img src={CarouselBackIcon} style={{  padding: '0.75em',marginLeft:'1em',marginRight:'0.5em',cursor:'default',opacity:'0.5'}}/>
                    }

                    {
                        artistno!==5 &&
                        <img src={CarouselNextIcon} className="artistCarouselBtn" onClick={()=>nextArtist()} />
                    }
                    {
                        artistno===5 &&
                        <img src={CarouselNextIcon} style={{  padding: '0.75em',cursor:'default',opacity:'0.5'}}/>
                      
                    }
                    
                   
                </div>
             </div>
        </div>
        }


        {/* ******************************************** */}


        {/* TABLET VIEW */}

        {
          dimensions.width >= 768 && dimensions.width <1024 &&
        <div style={{backgroundColor:'#0E141A',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingBottom:'5em',paddingTop:'5em',width:'100%'}}>
             
            

             <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'67.78%',maxWidth:'26.93em',position:'relative'}}>
                
                <img src={artistweworkllinestab} style={{width:'103.96px',height:'892.3px',position:'absolute',left:'-9.5em',top:'-0.2em',zIndex:'1'}}/>
                <img src={artistweworkrlinestab} style={{width:'61.67px',height:'433.31px',position:'absolute',right:'-5em',top:'15em',zIndex:'1'}}/>

                <div className="ArtistWeWrokWith" style={{marginBottom:'1.5em',width:'100%',minWidth:'26.93em',zIndex:'2'}}>
                        ARTISTS WE WORK WITH
                </div>
              
                <div style={{position:'relative',height:'57.745em',alignSelf:'center',width:'100%',minWidth:'29.93em'}}>
                 
                    <div style={{display:'flex',flexDirection:'column',position:'absolute'}} className={artist1style}>
                        <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                        <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/wjw0au0sdzneyznlyez4"} style={{aspectRatio:'1.01',zIndex:'4'}}/>
                        <img src={jayparktxt} style={{position:'absolute',right:'-32em',zIndex:'3',top:'-2em'}}/>
                        </div>

                        <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                            <div className="ArtistName">Jay Park</div>
                            <div className="ArtistRoles">Artist & Singer</div>

                            <div style={{display:'flex',flexDirection:'column'}}>
                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.2em'}}>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/vpafoxcuhqgjehmyiq9f"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/o3bfco7jd3c51vraw1jv"} style={{width:'45%',height:'10em'}}/>
                                </div>
                                <div style={{display:'flex',flexDirection:'row'}}>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/zssc6iwtjiuxbiufsizq"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/lesz4vnubvpr9gegr4mk"} style={{width:'45%',height:'10em'}}/>
                                </div>
                            
                            </div>

                        
                        </div>
                    </div>
   
                    <div style={{display:'flex',flexDirection:'column',position:'absolute'}} className={artist2style}>
                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/bnm36zixpuyawtojxms0"} style={{aspectRatio:'1.01',zIndex:'4'}}/>
                    <img src={djkhalidtxt} style={{position:'absolute',right:'-37em',zIndex:'3',top:'-2em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                        <div className="ArtistName">DJ Khaled</div>
                        <div className="ArtistRoles">Artist & Producer</div>

                        <div style={{display:'flex',flexDirection:'column'}}>
                            <div style={{display:'flex',flexDirection:'row',marginBottom:'0.2em'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/q0mqagwzssj4abztho9e"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/ua71x2vg6z3xx1rymi8n"} style={{width:'45%',height:'10em'}}/>
                            </div>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/enzrkcjmr9xeujswomao"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/mcaxqdkzdqgcq1y4qray"} style={{width:'45%',height:'10em'}}/>
                            </div>
                           
                        </div>
                      
                    </div>
                    </div>


                    <div style={{display:'flex',flexDirection:'column',position:'absolute'}} className={artist3style}>
                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/gehvac7zkmxbvmy4dby6"} style={{aspectRatio:'1.01',zIndex:'4'}}/>
                    <img src={jessitxt} style={{position:'absolute',right:'-16em',zIndex:'3',top:'-2em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                        <div className="ArtistName">Jessi</div>
                        <div className="ArtistRoles">Singer</div>

                        <div style={{display:'flex',flexDirection:'column'}}>
                            <div style={{display:'flex',flexDirection:'row',marginBottom:'0.2em'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/ijwopzo7za34eex59sh3"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/udpd7p23k2j5idbpcqzp"} style={{width:'45%',height:'10em'}}/>
                            </div>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/u06awxjbeyglrm8vqzd3"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/f4zmhpyruzmzmvgtdfpc"} style={{width:'45%',height:'10em'}}/>
                            </div>
                           
                        </div>
                       
                    </div>
                    </div>


                    <div style={{display:'flex',flexDirection:'column',position:'absolute'}} className={artist4style}>
                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/m6hklhckvdgkw3pq5sso"} style={{aspectRatio:'1.01',zIndex:'4'}}/>
                    <img src={koalatxt} style={{position:'absolute',right:'-17.5em',zIndex:'3',top:'-2em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                        <div className="ArtistName">Koala</div>
                        <div className="ArtistRoles">Artist</div>

                        <div style={{display:'flex',flexDirection:'column'}}>
                            <div style={{display:'flex',flexDirection:'row',marginBottom:'0.2em'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/tjgonfqqnupify7ohypt"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/osngv7hvwqgxmss6abg2"} style={{width:'45%',height:'10em'}}/>
                            </div>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yfjukfrwj4szfzvemgpe"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/l9xvets9at1k4zhqyezs"} style={{width:'45%',height:'10em'}}/>
                            </div>
                          
                        </div>

                     
                    </div>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'absolute'}} className={artist5style}>
                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={gray} style={{aspectRatio:'1.01',zIndex:'4'}}/>
                    <img src={graytxt} style={{position:'absolute',right:'-16.5em',zIndex:'3',top:'-2em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                        <div className="ArtistName">Gray</div>
                        <div className="ArtistRoles">Artist & Producer</div>

                        <div style={{display:'flex',flexDirection:'column'}}>
                            <div style={{display:'flex',flexDirection:'row',marginBottom:'0.2em'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/fqrtybfljzk4hga1yndc"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/pm4xtkqxcifhmnfjp6qz"} style={{width:'45%',height:'10em'}}/>
                            </div>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/zb0jfv6rfhrtulifjc6w"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/uzlbzjhvtd6pkjrzjjld"} style={{width:'45%',height:'10em'}}/>
                            </div>
                          
                        </div>


                    </div>
                    </div> 

                </div>

                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'2.5em',width:'100%',minWidth:'29.93em'}}>
                    <div style={{height:'1px',width:'74.94%',position:'relative',backgroundColor:'rgba(255,255,255,50%)'}}>
                      <div className={progress1style} style={{height:'1px',position:'absolute',backgroundColor:'#FF6694',zIndex:'2'}}/>
                    </div>
                    {
                        artistno!==1 &&
                        <img src={CarouselBackIcon} className="artistCarouselBtn" style={{marginLeft:'1em',marginRight:'0.5em'}} onClick={()=>prevArtist()}/>
                    }
                    {
                        artistno===1 &&
                        <img src={CarouselBackIcon} style={{  padding: '0.75em',marginLeft:'1em',marginRight:'0.5em',cursor:'default'}}/>
                    }

                    {
                        artistno!==5 &&
                        <img src={CarouselNextIcon} className="artistCarouselBtn" onClick={()=>nextArtist()} />
                    }
                    {
                        artistno===5 &&
                        <img src={CarouselNextIcon} style={{  padding: '0.75em',cursor:'default'}}/>
                      
                    }
                    
                   
                </div>
             </div>
        </div>
        }

        {/* ******************************************** */}


        {/* MOBILE VIEW */}

        {
          dimensions.width <768  &&
        <div style={{backgroundColor:'#0E141A',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingBottom:'5em',paddingTop:'5em',width:'100%'}}>
             
            

             <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'67.78%',maxWidth:'26.93em',position:'relative'}}>
                
                {/* <img src={artistweworkllinestab} style={{width:'103.96px',height:'892.3px',position:'absolute',left:'-9.5em',top:'-0.2em',zIndex:'1'}}/>
                <img src={artistweworkrlinestab} style={{width:'61.67px',height:'433.31px',position:'absolute',right:'-5em',top:'15em',zIndex:'1'}}/> */}

                <div className="ArtistWeWrokWith" style={{marginBottom:'1.5em',width:'100%',zIndex:'2',alignSelf:'flex-start'}}>
                        ARTISTS WE WORK WITH
                </div>
              
                <div style={{position:'relative',height:'54.745em',alignSelf:'center',width:'100%',overflow:'hidden'}}>
                 
                    <div style={{display:'flex',flexDirection:'column',position:'absolute'}} className={artist1style}>
                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/wjw0au0sdzneyznlyez4"} style={{aspectRatio:'1.01',zIndex:'4'}}/>
                    <img src={jayparktxt} style={{position:'absolute',right:'-32em',zIndex:'3',top:'-2em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                        <div className="ArtistName">Jay Park</div>
                        <div className="ArtistRoles">Artist & Singer</div>

                        <div style={{display:'flex',flexDirection:'column'}}>
                            <div style={{display:'flex',flexDirection:'row',marginBottom:'0.2em'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/vpafoxcuhqgjehmyiq9f"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/o3bfco7jd3c51vraw1jv"} style={{width:'45%',height:'10em'}}/>
                            </div>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/zssc6iwtjiuxbiufsizq"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/lesz4vnubvpr9gegr4mk"} style={{width:'45%',height:'10em'}}/>
                            </div>
                           
                        </div>

                      
                    </div>
                    </div>
                
                
                    <div style={{display:'flex',flexDirection:'column',position:'absolute'}} className={artist2style}>
                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/bnm36zixpuyawtojxms0"} style={{aspectRatio:'1.01',zIndex:'4'}}/>
                    <img src={djkhalidtxt} style={{position:'absolute',right:'-37em',zIndex:'3',top:'-2em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                        <div className="ArtistName">DJ Khaled</div>
                        <div className="ArtistRoles">Artist & Producer</div>

                        <div style={{display:'flex',flexDirection:'column'}}>
                            <div style={{display:'flex',flexDirection:'row',marginBottom:'0.2em'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/q0mqagwzssj4abztho9e"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/ua71x2vg6z3xx1rymi8n"} style={{width:'45%',height:'10em'}}/>
                            </div>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/enzrkcjmr9xeujswomao"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/mcaxqdkzdqgcq1y4qray"} style={{width:'45%',height:'10em'}}/>
                            </div>
                           
                        </div>
                       
                    </div>
                    </div>


                    <div style={{display:'flex',flexDirection:'column',position:'absolute'}} className={artist3style}>
                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/gehvac7zkmxbvmy4dby6"} style={{aspectRatio:'1.01',zIndex:'4'}}/>
                    <img src={jessitxt} style={{position:'absolute',right:'-16em',zIndex:'3',top:'-2em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                        <div className="ArtistName">Jessi</div>
                        <div className="ArtistRoles">Singer</div>

                        <div style={{display:'flex',flexDirection:'column'}}>
                            <div style={{display:'flex',flexDirection:'row',marginBottom:'0.2em'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/ijwopzo7za34eex59sh3"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/udpd7p23k2j5idbpcqzp"} style={{width:'45%',height:'10em'}}/>
                            </div>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/u06awxjbeyglrm8vqzd3"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/f4zmhpyruzmzmvgtdfpc"} style={{width:'45%',height:'10em'}}/>
                            </div>
                           
                        </div>

                     
                    </div>
                    </div>


                    <div style={{display:'flex',flexDirection:'column',position:'absolute'}} className={artist4style}>
                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/m6hklhckvdgkw3pq5sso"} style={{aspectRatio:'1.01',zIndex:'4'}}/>
                    <img src={koalatxt} style={{position:'absolute',right:'-17.5em',zIndex:'3',top:'-2em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                        <div className="ArtistName">Koala</div>
                        <div className="ArtistRoles">Artist</div>

                        <div style={{display:'flex',flexDirection:'column'}}>
                            <div style={{display:'flex',flexDirection:'row',marginBottom:'0.2em'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/tjgonfqqnupify7ohypt"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/osngv7hvwqgxmss6abg2"} style={{width:'45%',height:'10em'}}/>
                            </div>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yfjukfrwj4szfzvemgpe"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/l9xvets9at1k4zhqyezs"} style={{width:'45%',height:'10em'}}/>
                            </div>
                           
                        </div>
                       
                    </div>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'absolute'}} className={artist5style}>
                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={gray} style={{aspectRatio:'1.01',zIndex:'4'}}/>
                    <img src={graytxt} style={{position:'absolute',right:'-16.5em',zIndex:'3',top:'-2em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                        <div className="ArtistName">Gray</div>
                        <div className="ArtistRoles">Artist & Producer</div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <div style={{display:'flex',flexDirection:'row',marginBottom:'0.2em'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/fqrtybfljzk4hga1yndc"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/pm4xtkqxcifhmnfjp6qz"} style={{width:'45%',height:'10em'}}/>
                            </div>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/zb0jfv6rfhrtulifjc6w"} style={{width:'45%',height:'10em',marginRight:'0.4em'}}/>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/uzlbzjhvtd6pkjrzjjld"} style={{width:'45%',height:'10em'}}/>
                            </div>
                           
                        </div>
                      
                    </div>
                    </div> 

                </div>

                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'2.5em',width:'100%'}}>
                    <div style={{height:'1px',width:'74.94%',position:'relative',backgroundColor:'rgba(255,255,255,50%)'}}>
                      <div className={progress1style} style={{height:'1px',position:'absolute',left:'0em',backgroundColor:'#FF6694',zIndex:'2'}}/>
                    </div>
                    {
                        artistno!==1 &&
                        <img src={CarouselBackIcon} className="artistCarouselBtn" style={{marginLeft:'1em',marginRight:'0.5em'}} onClick={()=>prevArtist()}/>
                    }
                    {
                        artistno===1 &&
                        <img src={CarouselBackIcon} style={{  padding: '0.75em',marginLeft:'1em',marginRight:'0.5em',cursor:'default'}}/>
                    }

                    {
                        artistno!==5 &&
                        <img src={CarouselNextIcon} className="artistCarouselBtn" onClick={()=>nextArtist()} />
                    }
                    {
                        artistno===5 &&
                        <img src={CarouselNextIcon} style={{  padding: '0.75em',cursor:'default'}}/>
                      
                    }
                    
                   
                </div>
             </div>
        </div>
        }


        </div>
    );
}

export default ArtistCarousel;


